import React, { createRef, Component } from 'react'
import { Map, TileLayer, Marker, Popup } from 'react-leaflet'
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

const MyMarker = props => {

    const initMarker = ref => {
        if (ref) {
            ref.leafletElement.openPopup()
        }
    }

    return <Marker ref={initMarker} {...props} />
}

export default class MapSelector extends Component {
constructor(props) {
    super(props);
/*     this.state = !this.props.selected.lat ? {currentPos: null} : {currentPos:this.props.selected};
 */    this.handleClick = this.handleClick.bind(this);
}

state = {
    hasLocation: false,
    latlng: {
    lat: -33.1127433,
    lng: -64.3100224,
    },
    option:"",
    elegir: true,
    actual: true,
}

mapRef = createRef()

handleClickMap = () => {
    const map = this.mapRef.current
    if (map != null) {
    map.leafletElement.locate()
    }

}
handleClick(e) {
    this.props.select(e.latlng)
    this.setState({ latlng: e.latlng });
}
handleLocationFound = (e) => {
    this.props.select(e.latlng)
    this.setState({
    hasLocation: true,
    latlng:e.latlng,
    })
}
handleDoubleClick = () =>{
    this.setState({option:"actual", elegir:true, actual: false})
    const map = this.mapRef.current
    if (map != null) {
    map.leafletElement.locate()
    }
}
handleOption = ()=>{
    this.handleDoubleClick();
    setTimeout(()=>this.handleDoubleClick(), 1000);
}
handleOption2 = ()=>{
    this.setState({option:"buscar", elegir:false, actual:true})
}
onSubmit = ()=>{
    this.props.onSubmit()
}

render() {
    console.log(this.state)
    const marker = this.state.hasLocation ? (
    <Marker position={this.state.latlng}>
        <Popup>Ústed está aqui</Popup>
    </Marker>
    ) : null
    return (
    <>
        <Grid container direction="row" spacing={1}>
            <Grid item xs={6}>
                {this.state.actual ?
                    <Button 
                        style={{ width: "100%", color: "#FCFCFC", backgroundColor: "#0B3845",padding:"2px" }}
                        onClick={this.handleOption} 
                        variant="contained" >
                        <p style={{fontSize: 10, margin: "3px"}}>Ubicación actual</p>
                    </Button> 
                :
                    <Button 
                        disabled
                        style={{ width: "100%",padding:"2px" }}
                        variant="contained" >
                        <p style={{fontSize: 10, margin: "3px"}}>Ubicación actual</p>
                    </Button> 
                } 
            </Grid>
            <Grid item xs={6}>
                {this.state.elegir ?
                    <Button 
                        onClick={this.handleOption2} 
                        variant="contained" 
                        style={{ width: "100%", color: "#FCFCFC", backgroundColor: "#0B3845",padding:"2px" }}
                        >
                        <p style={{fontSize: 10, margin: "3px"}}>Escoger ubicación</p>
                    </Button> 
                :
                    <Button 
                        disabled
                        variant="contained" 
                        style={{ width: "100%", padding:"2px" }}
                        >
                        <p style={{fontSize: 10, margin: "3px"}}>Escoger ubicación</p>
                    </Button> 
                }
            </Grid>
        </Grid>
        { this.state.option==="actual" ? 
            <Map
                style={{ height: "80%", width: "100%",borderRadius:"15px", marginTop:"10px" }}
                center={this.state.latlng}
                length={4}
                onClick={this.handleClick}
                onLocationfound={this.handleLocationFound}
                ref={this.mapRef}
                zoom={13}
                tap={false}
                >
                <TileLayer
                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {marker}
                </Map>
        :
            <Map
                style={{ height: "80%", width: "100%",borderRadius:"15px", marginTop:"10px" }}
                center={this.state.latlng}
                onClick={this.handleClick}
                zoom={13}
                >
                <TileLayer
                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {this.state.latlng && <MyMarker position={!this.props.selected.lat?this.state.latlng:this.props.selected}></MyMarker>}
            </Map>
        } 
        <Grid item xs={6}></Grid>
        <Grid item xs={6}>
        <Button
            variant="contained"
            fullWidth
            color="primary"
            style={{ width: "100%", color: "#FCFCFC", backgroundColor: "#0B3845", marginTop:"10px" }}
            onClick={this.props.onSubmit}
        >
            Elegir
        </Button>
        </Grid>
    </>
    )
}
}